import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable()
export abstract class ValidatorService {
    abstract getRowValidator(): FormGroup;
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/servicios/validator.service.ts